import "./App.scss";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./createStore";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useLocation, useHistory } from "react-router-dom";
import AppWrapper from "./components/AppWrapper";
import APIErrorProvider from "./common/providers/APIErrorProvider";
import AUTHProvider from "./common/providers/AUTHProvider";
import SearchSYNProvider from "./common/providers/SearchSYNProvider";
import APIErrorNotification from "./components/APIErrorNotification";
import { WithAxios } from "./axios/WithAxios";
import Storage from "./common/lib/storage";
import { apiGetUserName } from "./resource/index";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import theme from './constants/theme';
import useDavinciWatermark from './util/waterMarkHelper';
import { XSSRecoverText } from "./util/xssHelper";

function App() {
  const { updateWatermark } = useDavinciWatermark("Default WaterMark");
  let history = useHistory();
  let urlToken_input = new URLSearchParams(useLocation().search).get("token");
  let regulator = new URLSearchParams(useLocation().search).get("regulator");
  let urlToken = '';
  // Remove spaces within token, as these would cause backend failure.
  if (urlToken_input) {
    urlToken = urlToken_input.replace(/\s+/g, '');
  }
  urlToken && Storage.saveToken(urlToken);
  regulator && Storage.saveRegulator(regulator);

  useEffect(() => {
    let entry_point = '';
    const getUserName = async () => {
      const { data } = (await apiGetUserName()).data;
      data.user.psp_role && Storage.savePSPRole(data.user.psp_role);
      data.user.name && Storage.saveUserName(data.user.name);
      data.user.blacklist && Storage.saveBlacklist(data.user.blacklist);
      data.user.search_role && Storage.saveSearchRole(data.user.search_role);
      data.user.download_role && Storage.saveDownloadRole(data.user.download_role);
      data.user.daily_report_role && Storage.saveDailyReportRole(data.user.daily_report_role);
      data.user.campaign_report_role && Storage.saveCampaignReportRole(data.user.campaign_report_role);
      data.user.report_download_role && Storage.saveReportDownloadRole(data.user.report_download_role);
      if ('display_click_id' in data.user) {
        Storage.saveDisplayClickID(data.user.display_click_id);
      }

      Storage.saveEnableLicenseFilter(data.user.enable_license_filter || false);
      Storage.saveEnableLicenseFilterRegulators(data.user.enable_license_filter_regulators || []);

      if ('entry_point' in data.user) {
        entry_point = data.user.entry_point;
      } else {
        entry_point = "/rebateReport";
      }
    };

    getUserName().then(() => {
      urlToken && history.push(entry_point);
    });

    updateWatermark(`${XSSRecoverText(Storage.getUserName()) ?? ""}`);
  }, [urlToken, regulator, history]);

  return (
    <Provider store={store}>
      <div className="App">
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <AUTHProvider>
                <APIErrorProvider>
                  <SearchSYNProvider>
                    <WithAxios>
                      <AppWrapper />
                      <APIErrorNotification />
                    </WithAxios>
                  </SearchSYNProvider>
                </APIErrorProvider>
              </AUTHProvider>
            </LocalizationProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </div>
    </Provider>
  );
}

export default App;
